'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Removes value from multiple or single value
 * @return {Array|String|Number|Null} new value
 */
function deselectValue(_ref) {
  var id = _ref.id,
      value = _ref.value,
      _ref$getIdProperty = _ref.getIdProperty,
      getIdProperty = _ref$getIdProperty === undefined ? function (item) {
    return item && item.id;
  } : _ref$getIdProperty;

  var newValue = void 0;
  var singleValueId = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? getIdProperty(value) : value;
  if (id === singleValueId || singleValueId === null) {
    newValue = null;
  }
  if (Array.isArray(value)) {
    newValue = value.filter(function (value) {
      var valueId = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? getIdProperty(value) : value;
      return valueId !== id;
    });
    if (!newValue.length) {
      newValue = null;
    }
  }

  return newValue;
}

exports.default = deselectValue;